<qrcode [qrdata]="url"
        [width]="200"
        [errorCorrectionLevel]="'M'"
        [cssClass]="'center'"
        [colorDark]="'#000000ff'"
        [colorLight]="'#ffffffff'"
        [elementType]="'canvas'"
></qrcode>
